// extracted by mini-css-extract-plugin
export default {"submitBtn":"SubmitBtn_submitBtn__7RnEY","submitBtnText":"SubmitBtn_submitBtnText__Sr-UI"};